import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {

      
      //English Translation for Service page
      serviceTitle: "The Service You Deserve,",
      serviceSubtitle: "The Service We Give!",
      serviceDescription:
        "We provide tailored IT solutions with a focus on innovation, security, and scalability. From expert tech support to custom web development, our dedicated team ensures your technology works seamlessly for you.",
      curiousAbout: "Curious about how SAM-IT UB can transform your digital experience?",
      findOutNow: "Find Out",
      exploreWork: "Explore our work in action and see why businesses and individuals trust us to drive their success!",
      liveDemonstartion: "Live Demo",
      ourServices: "Our Services",
      serviceHeading: "The Best Defense is a Good Offense.",
      serviceDetails:
        "As a leading Managed Service Provider in Agder, Sam-IT Technology Solutions partners with clients to take a proactive role in your IT. We mitigate problems before they happen. When issues do arise, your team will have 24/7/365 access to IT support and a live Help Desk.",
      itSupport: "IT Support",
      managedServices: "Managed Services",
      security: "Security",
      helpDesk: "Help Desk",


      servicesHeading: "Our Services",
      servicesSubtitle: "The Best Defense is a Good Offense.",
      servicesDescription: `
        As a leading Managed Service Provider in Agder, Sam-IT Technology
        Solutions partners with clients to take a proactive role in your IT.
        We mitigate problems before they happen. When issues do arise, your team
        will have 24/7/365 access to IT support and a live Help Desk.`,
      theServiceYouDeserve: "The Service You Deserve",
      theServiceWeGive: "The Service We Give!",
      curiousAboutTransform: "Curious about how SAM-IT UB can transform your digital experience?",
      findOut: "Find Out",
      exploreOurWork: "Explore our work in action and see why businesses and individuals trust us to drive their success!",
      liveDemo: "Live Demo",
      features: {
        itSupport: "IT Support",
        itSupportDescription: "Computer & Network Setup, Management and Support. Vendor Coordination.",
        managedServices: "Managed Services",
        managedServicesDescription: "IT System Planning and Maintenance. Proactive Monitoring. On-Demand Support.",
        security: "Security",
        securityDescription: "Malware Protection. Monitoring. Vulnerability Analysis. Data Recovery Planning.",
        helpDesk: "Help Desk",
        helpDeskDescription: "Direct Support to End Users.",
      },

//English Translation for WhoWeAre page

      whoAreWeTitle: "Who Are We?",
      whoAreWeDescription: `
        SAM-IT UB is a student-driven company offering IT user support and
        development services for both individuals and businesses. We provide
        efficient, reliable solutions for your digital needs, whether it’s
        technical support or web development.`,
      whoAreWeMoreDescription: `
        We combine innovative thinking with hands-on expertise
        to provide high-quality IT services. Our team of dedicated students
        focuses on scalability, security, and seamless solutions, ensuring
        your business operates smoothly in today’s tech-driven world. From
        tailored web applications to personalized support, we’re here to
        enhance your digital experience and help you succeed.`,
      followUs: "Follow Us and Find Out More!",

       //English Translation for ChooseSamIT UB  section
"chooseSamIT":{
  "h1": "Why choose Sam-IT?",
  "wrapper1": "Each of our clients has a dedicated contact; get the same person every time you call.",
  "wrapper2": "Lost time equals lost revenue. We respond immediately when issues occur.",
  "wrapper3": "A good plan mitigates many possible issues. We tailor your IT plan to meet your needs.",
  "wrapper4": "We are a Certified Solutions Expert for 20+ leading vendors.",
  "wrapper5": "We work as an extension of your team. We’ll help you reach your goals."
},

      //English Translation for About Us page
      about_us: {
        title: "About Sam-IT UB",
        intro1:
          "SAM-IT is a student-driven company offering IT user support and development services for both individuals and businesses. We provide efficient, reliable solutions for your digital needs, whether it’s technical support or web development.",
        intro2:
          "We combine innovative thinking with hands-on expertise to provide high-quality IT services. Our team of dedicated students focuses on scalability, security, and seamless solutions, ensuring your business operates smoothly in today’s tech-driven world. From tailored web applications to personalized support, we’re here to enhance your digital experience and help you succeed.",
        mission_title: "Our Mission",
        mission:
          "Our mission is to empower businesses and individuals with innovative IT strategies and solutions that streamline processes, enhance productivity, and foster growth.",
        vision_title: "Our Vision",
        vision:
          "To be the trusted partner for businesses around Agder, offering cutting-edge IT solutions and consultancy that drive innovation and success.",
        why_choose_us: "Why Choose Us?",
        expert_team_title: "Expert Team",
        expert_team_desc:
          "Work with industry-leading professionals dedicated to providing exceptional IT solutions.",
        tailored_solutions_title: "Tailored Solutions",
        tailored_solutions_desc:
          "Receive customized strategies designed to meet your unique business challenges.",
        proven_results_title: "Proven Results",
        proven_results_desc:
          "Benefit from solutions that deliver measurable success for our clients.",
        cta_title: "Ready to Partner With Us?",
        cta_desc:
          "Let’s transform your business with expert IT solutions and consultancy.",
        contact_us: "Contact Us",
  
      },
      

//English Translation for Product page
  "product": {
    "header": "Discover Your Perfect Gadget",
    "subHeader": "Whether you need a laptop for school, business, gaming, or personal work, our experts can help you choose the best quality product to meet your needs.",
    "imageAlt": "Consultation Service",
    "whyChooseUs": {
      "title": "Why Choose Us?",
      "point1": "Personalized recommendations tailored to your needs.",
      "point2": "Expert guidance to ensure top quality and value.",
      "point3": "Access to exclusive deals and trusted brands.",
      "point4": "Save time and avoid confusion with professional advice."
    },
    "cta": {
      "title": "Still not sure? Let our experts guide you!",
      "subText": "Book a free consultation, and we'll help you make an informed decision based on your specific needs.",
      "buttonText": "Talk to an Expert"
    }
  },


  //English Translation for Faq Page
"faq": {
    "pageTitle": "Frequently Asked Questions",
    "pageDescription": "Answered all frequently asked questions,",
    "pageStillConfused": "Still confused?",
    "contactLinkText": "Feel free to contact us.",
    
    "qn_1": "1. What services does your consultancy offer?",
    "ans_1": "We provide a range of services, including IT user support, technical troubleshooting, web development, custom software development, cybersecurity solutions, and digital transformation consultancy.",
    "qn_2": "2. How do I know if I need IT consultancy services?",
    "ans_2": "If you are experiencing frequent technical issues, need to enhance your business’s digital infrastructure, or are looking for expert advice to improve operational efficiency, IT consultancy can provide tailored solutions.",
    "qn_3": "3. What is the process for engaging your services?",
    "ans_3": "The process begins with an initial consultation to assess your needs. We then provide a detailed proposal that outlines our approach, timelines, and deliverables.",
    "qn_4": "4. Are your services industry-specific?",
    "ans_4": "Our team has experience across various industries, allowing us to deliver customized IT solutions that cater to the unique needs of different business sectors.",
    "qn_5": "5. How can your services improve my business performance?",
    "ans_5": "Our IT solutions focus on optimizing workflows, enhancing security, increasing scalability, and implementing innovative tools to streamline operations and improve productivity.",
    "qn_6": "6. What sets SAM-IT UB apart from other consultancy firms?",
    "ans_6": "Our student-driven team combines innovative thinking, practical expertise, and a fresh perspective on problem-solving, ensuring cost-effective, scalable, and secure solutions. ",
    "qn_7":"7. Do you provide ongoing technical support?",
    "ans_7":" Yes, we offer both one-time assistance and ongoing support services to ensure your IT systems operate seamlessly over time.",
    "qn_8":"8. Can you assist with web development projects? ",
    "ans_8":"Absolutely! Our web development services include custom application design, responsive website development, maintenance, and optimization to meet your unique business needs. ",
    "qn_9":"9. How do you ensure data security in your solutions? ",
    "ans_9":" We prioritize security by implementing advanced data encryption, proactive monitoring, vulnerability analysis, and disaster recovery planning in all our solutions.",
    "qn_10":"10. Do you work with individuals as well as businesses?",
    "ans_10":"Yes, we provide services to both individuals and businesses. Whether you’re an entrepreneur, a student, or a company, our tailored solutions are designed for everyone. ",
    "readMore": " Read More...",
  },

//English Translation for banner page
"banner":{
  "title1": "When it comes to your IT, everything is mission critical.",
  "title2": "We stand by the expertise and consulting we provide.",
  "bookingBtn": "BOOK A CONSULTATION",
},

 //Enlish Translation for DreamsToLife section
 "dreamsToLife" : {
  "title": " Lets bring your Dreams to Life",
  "intro1": " We provide everything you need to develop, deploy, and maintain your applications seamlessly.",
  "intro2": " Our team is here to help you at every step, from concept to launch, ensuring you have the right tools and support to achieve your goals. ",
  "1h3": " Push to deploy",
  "1p1": " Easily bring your applications to life with our streamlined deployment services. With just a few steps, your app can be live and accessible.",
  "1p2": " Our platform simplifies the deployment process so you can focus on what truly matters — building a great product.",
  "2h3": " SSL certificates",
  "2p1": " We take security seriously. All our services come with SSL certificates to protect your app and user data, ensuring a secure environment and building trust with your users.",
  "2p2": "Enjoy peace of mind knowing your application meets industry security standards. ",
  "3h3": " Reliable Support",
  "3p1": " Our team is dedicated to providing you with responsive, knowledgeable support.",
  "3p2": "   Whether it’s troubleshooting or guidance on best practices, we're here to assist you every step of the way so you can focus on your core business.",
  "4h3": " Advanced security",
  "4p1": " Safeguard your application with advanced security measures tailored to your needs.",
  "4p2": "We provide multi-layered protection, monitoring, and proactive threat management to keep your data and users safe from vulnerabilities. ",

},

 //English Translation for digital Journey banner
 "digitalJourney": {
  "h2": "Empowering Your Digital Journey",
  "p": "We believe in building lasting partnerships with our clients. Our team is dedicated to providing personalized solutions that meet your - unique business needs, delivering exceptional service and support every step of the way."
  },
  
  //English Translation for blog section
"blog" :{
  "blogTitle": "Latest News and Blog Posts",
  "blogDesc": "Stay up to date with what's happening with our latest posts ",
  "blog_1_h2": "Our Office Location ",
  "blog_1_h3": " Welcom to our offices in Arendal",
  "blog_1_p1": "  At Sam-IT UB, we're excited to announce our expanded presence in Arendal, where we continue to offer IT support and solutions to everyone.",
  "blog_1_p2": " Our new office in Arendal serves as a hub for innovation and collaboration, where... ",
  "blogLink": "Learn More...",

"blog_2_h2": " User Support",
"blog_2_h3": "5 Common IT Problems and How to Solve them ",
"blog_2_p": " Sam-IT UB provides reliable IT support services, including troubleshooting, software installation, and cybersecurity. Our team ensures smooth and secure operations... ",

"blog_3_h2": "Atea Community",
"blog_3_h3": "See technology trends in Kristiansand",
"blog_3_p": "Join us for a day of professional enrichment, inspiration and networking.",


"blog_4_h2": "The Future of IT ",
"blog_4_h3": " Trends to Watch in 2024 and Beyond",
"blog_4_p": "  As technology evolves rapidly, staying ahead of key IT trends in 2024 and beyond is crucial for businesses and individuals to maintain a competitive edge and therefore, Sam-IT is...",

"blog_5_h2": "Are You Hiring an IPS? ",
"blog_5_h3": " What to Look for When Choosing an IT Service Provider",
"blog_5_p": "  It is important to find an employer that aligns with your values and work style. If you value work-life balance, you should...",

"blog_6_h2": "Upcoming Event! ",
"blog_6_h3": "  Slush'D Energy 2025-Are Your Coming?",
"blog_6_p": " Digin is co-hosting Slush'D Energy on March 12, 2025, in Mandal, bringing together startups, investors, and industry leaders to focus on sustainability, clean-tech, energy, AI...",

"blog_7_h2": " Sam-IT UB Day",
"blog_7_h3": "Launching Our Project Posters to the Public ",
"blog_7_p": " Sam-IT UB are thrilled to announce that we will soon begin distributing our project posters as part of our advertising campaign.... ",

"blog_8_h2": "Cyber Security ",
"blog_8_h3": " Cybersecurity Best Practices for Businesses ",
"blog_8_p": "  In today’s digital world, protecting your business from cyber threats is vital. Sam-IT UB wants to share key practices to secure data, prevent breaches, and keep your business...",
  },

  //English Translation for discord banner
  "discordBanner":{
    "title1": "POWERED BY INNOVATION",
    "title2": "Join Our Discord Support Community",
    "p": "Join our community on Discord for seamless tech support and personalized assistance, and experience the difference SAM-IT can make in driving your digital success!"
  },
    },
  },



//.......................................................................................................//

//.......................................................................................................//


//Nosrk Translation for Service page
  no: {
    translation: {
      serviceTitle: "Tjenesten du fortjener,",
      serviceSubtitle: "Tjenesten vi gir!",
      serviceDescription:
        "Vi tilbyr skreddersydde IT-løsninger med fokus på innovasjon, sikkerhet og skalerbarhet. Fra ekspert teknisk støtte til tilpasset webutvikling, vårt dedikerte team sørger for at teknologien fungerer sømløst for deg.",
      curiousAbout: "Nysgjerrig på hvordan SAM-IT UB kan transformere din digitale opplevelse?",
      findOutNow: "Finn ut",
      exploreWork: "Utforsk arbeidet vårt i praksis og se hvorfor bedrifter og enkeltpersoner stoler på oss for å drive deres suksess!",
      liveDemonstartion: "Live Demo",
      ourServices: "Våre tjenester",
      serviceHeading: "Det beste forsvaret er et godt angrep.",
      serviceDetails:
        "Som en ledende tjenesteleverandør i Agder samarbeider Sam-IT Technology Solutions med kunder for å ta en proaktiv rolle i din IT. Vi begrenser problemer før de oppstår. Når problemer oppstår, vil teamet ditt ha tilgang til IT-støtte og en live Help Desk hele døgnet.",
      itSupport: "IT-støtte",
      managedServices: "Administrerte tjenester",
      security: "Sikkerhet",
      helpDesk: "Hjelp",


      servicesHeading: "Våre Tjenester",
      servicesSubtitle: "Det beste forsvaret er et godt angrep.",
      servicesDescription: `
        Som en ledende leverandør av administrerte tjenester i Agder, samarbeider
        Sam-IT Technology Solutions med klienter for å ta en proaktiv rolle i deres IT.
        Vi løser problemer før de oppstår. Når problemer oppstår, vil teamet ditt ha
        tilgang til IT-støtte og en live Help Desk 24/7/365.`,
      theServiceYouDeserve: "Tjenesten Du Fortjener",
      theServiceWeGive: "Tjenesten Vi Gir!",
      curiousAboutTransform: "Er du nysgjerrig på hvordan SAM-IT UB kan transformere din digitale opplevelse?",
      findOut: "Finn Ut",
      exploreOurWork: "Utforsk vårt arbeid i aksjon og se hvorfor bedrifter og enkeltpersoner stoler på oss for å drive deres suksess!",
      liveDemo: "Live Demo",
      features: {
        itSupport: "IT-støtte",
        itSupportDescription: "Oppsett, administrasjon og støtte for datamaskiner og nettverk. Leverandørkoordinering.",
        managedServices: "Administrerte Tjenester",
        managedServicesDescription: "Planlegging og vedlikehold av IT-systemer. Proaktiv overvåking. Støtte på forespørsel.",
        security: "Sikkerhet",
        securityDescription: "Beskyttelse mot skadelig programvare. Overvåking. Sårbarhetsanalyse. Planlegging for datagjenoppretting.",
        helpDesk: "Brukerstøtte",
        helpDeskDescription: "Direkte støtte til sluttbrukere.",
      },



    //Norsk Translation for WhoWeAre page
      whoAreWeTitle: "Hvem Er Vi?",
      whoAreWeDescription: `
        SAM-IT UB er et studentdrevet selskap som tilbyr IT-brukerstøtte og
        utviklingstjenester for både enkeltpersoner og bedrifter. Vi tilbyr
        effektive, pålitelige løsninger for dine digitale behov, enten det er
        teknisk støtte eller webutvikling.`,
      whoAreWeMoreDescription: `
        Vi kombinerer innovativ tenkning med praktisk ekspertise
        for å tilby høy kvalitet på IT-tjenester. Vårt team av dedikerte studenter
        fokuserer på skalerbarhet, sikkerhet og sømløse løsninger, og sørger for
        at din virksomhet opererer effektivt i dagens teknologi-drevne verden. Fra
        skreddersydde webapplikasjoner til personlig støtte, er vi her for å
        forbedre din digitale opplevelse og hjelpe deg å lykkes.`,
      followUs: "Følg Oss og Finn Ut Mer!",

      //Norsk Translation for ChooseSamIT UB  section
"chooseSamIT":{
  "h1": "Hvorfor Velge Sam-IT?",
  "wrapper1": "Hver av våre kunder har en dedikert kontakt; få samme person hver gang du Ringer.",
  "wrapper2": "Tapt tid er lik tapt inntekt. Vi svarer umiddelbart når problemer oppstår!.",
  "wrapper3": "En god plan reduserer mange mulige problemer. Vi skreddersyr din IT-plan for å møte dine behov.",
  "wrapper4": "Vi jobber som en forlengelse av teamet ditt. Vi hjelper deg med å nå dine mål",
},

 //Norsk Translation for About Us page
      about_us: {
        title: "Om Sam-IT UB",
        intro1:
          "SAM-IT er et studentdrevet selskap som tilbyr IT-brukerstøtte og utviklingstjenester for både enkeltpersoner og bedrifter. Vi tilbyr effektive, pålitelige løsninger for dine digitale behov, enten det gjelder teknisk support eller webutvikling.",
        intro2:
          "Vi kombinerer innovativ tenkning med praktisk ekspertise for å levere IT-tjenester av høy kvalitet. Vårt team av dedikerte studenter fokuserer på skalerbarhet, sikkerhet og sømløse løsninger, og sørger for at din virksomhet fungerer problemfritt i dagens teknologidrevne verden. Fra skreddersydde webapplikasjoner til personlig støtte, er vi her for å forbedre din digitale opplevelse og hjelpe deg å lykkes.",
        mission_title: "Vårt Oppdrag",
        mission:
          "Vårt oppdrag er å styrke bedrifter og enkeltpersoner med innovative IT-strategier og løsninger som effektiviserer prosesser, øker produktiviteten og fremmer vekst.",
        vision_title: "Vår Visjon",
        vision:
          "Å være den pålitelige partneren for bedrifter i Agder, som tilbyr banebrytende IT-løsninger og rådgivning som driver innovasjon og suksess.",
        why_choose_us: "Hvorfor Velge Oss?",
        expert_team_title: "Ekspertteam",
        expert_team_desc:
          "Jobb med bransjeledende fagfolk som er dedikert til å levere eksepsjonelle IT-løsninger.",
        tailored_solutions_title: "Skreddersydde Løsninger",
        tailored_solutions_desc:
          "Få tilpassede strategier designet for å møte dine unike forretningsutfordringer.",
        proven_results_title: "Beviste Resultater",
        proven_results_desc:
          "Dra nytte av løsninger som gir målbar suksess for våre kunder.",
        cta_title: "Klar til å Samarbeide Med Oss?",
        cta_desc:
          "La oss transformere virksomheten din med ekspert IT-løsninger og rådgivning.",
        contact_us: "Kontakt Oss",
      },

//Nosrk Translation for Product page
"product": {
    "header": "Finn den perfekte Dingsen",
    "subHeader": "Enten du trenger en bærbar PC til skole, jobb, gaming eller personlig bruk, kan våre eksperter hjelpe deg med å velge det beste produktet for dine behov.",
    "imageAlt": "Konsultasjonstjeneste",
    "whyChooseUs": {
      "title": "Hvorfor velge oss?",
      "point1": "Personlige anbefalinger tilpasset dine behov.",
      "point2": "Ekspertråd for å sikre topp kvalitet og verdi.",
      "point3": "Tilgang til eksklusive tilbud og pålitelige merker.",
      "point4": "Spar tid og unngå forvirring med profesjonelle råd."
    },
    "cta": {
      "title": "Fortsatt usikker? La våre eksperter veilede deg!",
      "subText": "Bestill en gratis konsultasjon, så hjelper vi deg med å ta en informert beslutning basert på dine spesifikke behov.",
      "buttonText": "Snakk med en ekspert"
    }
  },

  //Norsk Translation for Faq Page
  "faq": {
    "pageTitle": "Ofte Stilte Spørsmål",
    "pageDescription": "Svar på alle ofte stilte spørsmål.",
    "pageStillConfused": "Fortsatt usikker? ",
    "contactLinkText": "Ikke nøl med å kontakte Oss.",
   
    "qn_1" : "1. Hvilke tjenester tilbyr deres konsulentselskap? ",
    "ans_1": "Vi tilbyr et bredt spekter av tjenester, inkludert IT-brukerstøtte, teknisk feilsøking, webutvikling, skreddersydd programvareutvikling, cybersikkerhetsløsninger og rådgivning om digital transformasjon ",
    "qn_2" : "2. Hvordan vet jeg om jeg trenger IT-rådgivning? ",
    "ans_2": "Hvis du opplever hyppige tekniske problemer, trenger å forbedre den digitale infrastrukturen i bedriften din, eller søker ekspertråd for å effektivisere driften, kan vi tilby skreddersydde løsninger. ",
    "qn_3" : "3. Hvordan fungerer prosessen for å engasjere deres tjenester? ",
    "ans_3": " Prosessen starter med en innledende konsultasjon for å vurdere dine behov. Deretter gir vi et detaljert forslag som beskriver vår tilnærming, tidslinje og leveranser.",
    "qn_4" : "4. Er tjenestene deres bransjespesifikke?",
    "ans_4": "Vårt team har erfaring fra flere bransjer, noe som gjør oss i stand til å levere tilpassede IT-løsninger for ulike sektorer. ",
    "qn_5" : "5. Hvordan kan deres tjenester forbedre min bedrifts ytelse? ",
    "ans_5": " Våre IT-løsninger fokuserer på å optimalisere arbeidsflyt, forbedre sikkerhet, øke skalerbarhet og implementere innovative verktøy for å effektivisere operasjoner og øke produktivitet.",
    "qn_6" : "6. Hva skiller SAM-IT UB fra andre konsulentfirmaer?",
    "ans_6": " Vårt studentdrevne team kombinerer innovativ tenkning, praktisk ekspertise og en moderne tilnærming, noe som sikrer kostnadseffektive, skalerbare og sikre løsninger.",
    "qn_7" : " 7. Tilbyr dere løpende teknisk støtte? ",
    "ans_7": " Ja, vi tilbyr både engangshjelp og løpende støttetjenester for å sikre at dine IT-systemer fungerer problemfritt over tid.",
    "qn_8" : "8.  Kan dere hjelpe med webutviklingsprosjekter?",
    "ans_8": "Absolutt! Våre webutviklingstjenester inkluderer design av skreddersydde applikasjoner, utvikling av responsivt design, vedlikehold og optimalisering for å oppfylle dine behov. ",
    "qn_9" : "9. Hvordan sikrer dere datasikkerhet i løsningene deres? ",
    "ans_9": " Vi prioriterer sikkerhet ved å implementere avansert datakryptering, proaktiv overvåking, sårbarhetsanalyser og planer for gjenoppretting etter katastrofer.",
    "qn_10" : " 10. Jobber dere med enkeltpersoner så vel som bedrifter?",
    "ans_10": " Ja, vi tilbyr tjenester både til enkeltpersoner og bedrifter. Enten du er gründer, student eller en virksomhet, er våre skreddersydde løsninger designet for alle.",
    
    "readMore": " Les Mer...",
  },
  

  //Norsk Translation for Consultation banner Page
    "banner": {
      "title1": "Når det gjelder IT-en din, er alt kritisk for suksess.",
      "title2": "Vi står bak den ekspertisen og rådgivningen vi tilbyr.",
      "bookingBtn": "BESTILL EN KONSULTASJON",
    },
 //Norsk Translation for digital Journey banner
  "digitalJourney": {
    "h2": "Styrk Din Digitale Reise",
    "p": "Vi tror på å bygge varige partnerskap med våre kunder. Vår teamet er dedikert til å tilby personlige løsninger som møtes dine - unike forretningsbehov, levere eksepsjonell service og støtte hvert steg på veien."
    },
    
 //Norsk Translation for DreamsToLife section
 "dreamsToLife" : {
  "title": " La oss gjøre Drømmene dine til Virkelighet ",
  "intro1": " Vi tilbyr alt du trenger for å utvikle, distribuere og vedlikeholde applikasjonene dine sømløst.",
  "intro2": " Teamet vårt er her for å hjelpe deg på hvert trinn, fra konsept til lansering, for å sikre at du har de riktige verktøyene og støtten for å nå dine mål. ",
  "1h3": " Trykk for å Distribuere",
  "1p1": " Få applikasjonene dine til live med våre strømlinjeformede distribusjonstjenester. Med bare noen få trinn kan appen din være live og tilgjengelig.",
  "1p2": " Plattformen vår forenkler distribusjonsprosessen slik at du kan fokusere på det som virkelig betyr noe – å bygge et flott produkt.",
  "2h3": " SSL Sertifikater",
  "2p1": " Vi tar sikkerhet på alvor. Alle tjenestene våre kommer med SSL-sertifikater for å beskytte appen og brukerdataene dine, for å sikre et sikkert miljø og bygge tillit hos brukerne dine.",
  "2p2": "Nyt trygghet når du vet at applikasjonen din oppfyller bransjesikkerhetsstandarder.",
  "3h3": " Pålitelig Støtte",
  "3p1": " Teamet vårt er dedikert til å gi deg responsiv, kunnskapsrik støtte.",
  "3p2": "Enten det er feilsøking eller veiledning om beste praksis, er vi her for å hjelpe deg hele veien slik at du kan fokusere på kjernevirksomheten din.",
  "4h3": " Avansert Sikkerhet",
  "4p1": " Beskytt applikasjonen din med avanserte sikkerhetstiltak skreddersydd for dine behov.",
  "4p2": "Vi tilbyr flerlags beskyttelse, overvåking og proaktiv trusselhåndtering for å holde dataene dine og brukerne dine trygge mot sårbarheter.",

},
//Norsk Translation for blog section
"blog" :{
"blogTitle": " Siste Nyheter og Blogginnlegg ",
"blogDesc": "Hold deg oppdatert på hva som skjer med våre siste innlegg ",
"blog_1_h2": "Vårt kontorsted",
"blog_1_h3": "Velkommen til våre kontorer i Arendal",
"blog_1_p1": "På Sam-IT UB er vi glade for å kunngjøre vår utvidede tilstedeværelse i Arendal, hvor vi fortsetter å tilby IT-støtte og løsninger til alle.",
"blog_1_p2": "Vårt nye kontor i Arendal fungerer som et knutepunkt for innovasjon og samarbeid, hvor... ",
"blogLink": "Les Mer...",

"blog_2_h2": " Brukerstøtte",
"blog_2_h3": " 5 Vanlige IT-problemer og hvordan du løser dem",
"blog_2_p": "Sam-IT UB tilbyr pålitelige IT-støttetjenester, inkludert feilsøking, programvareinstallasjon og cybersikkerhet. Teamet vårt sørger for jevn og sikker drift...",

"blog_3_p1": " ",
"blog_3_h2": "Atea Community",
"blog_3_h3": "Se teknologitrender i Kristiansand",
"blog_3_p": "Bli med på en dag for faglig påfyll, inspirasjon og nettverksbygging.",

"blog_4_h2": "Fremtiden til IT ",
"blog_4_h3": "Trender å se i 2024 og utover ",
"blog_4_p": " Ettersom teknologien utvikler seg raskt, er det avgjørende for bedrifter og enkeltpersoner å holde seg i forkant av viktige IT-trender i 2024 og fremover for å opprettholde et konkurransefortrinn, og derfor er Sam-IT...",

"blog_5_h2": "Ansetter du en IPS? ",
"blog_5_h3": "Hva du bør se etter når du velger en IT-tjenesteleverandør ",
"blog_5_p": " Det er viktig å finne en arbeidsgiver som er i tråd med dine verdier og arbeidsstil. Hvis du verdsetter balanse mellom arbeid og privatliv, bør du...",

"blog_6_h2": " Kommende Arrangement!",
"blog_6_h3": "Slush'D Energy 2025 – Kommer du? ",
"blog_6_p": " Digin er vertskap for Slush'D Energy 12. mars 2025 i Mandal, og samler startups, investorer og industriledere for å fokusere på bærekraft, clean-tech, energi, AI...",

"blog_7_h2": " Sam-IT UB-dagen",
"blog_7_h3": "Lansering av prosjektplakatene våre for publikum ",
"blog_7_p": " Sam-IT UB er glade for å kunngjøre at vi snart vil begynne å distribuere prosjektplakatene våre som en del av vår reklamekampanje....",

"blog_8_h2": " Cyber Sikkerhet",
"blog_8_h3": " Beste praksis for cybersikkerhet for bedrifter",
"blog_8_p": " I dagens digitale verden er det viktig å beskytte virksomheten din mot cybertrusler. Sam-IT UB ønsker å dele nøkkelpraksis for å sikre data, forhindre brudd og holde virksomheten din... ",
},

//Norsk Translation for discord banner
    "discordBanner":{
      "title1": "DREVET AV INNOVASJON",
      "title2": "Bli med i Discord Support Community",
      "p": "Bli med i fellesskapet vårt på Discord for sømløs teknisk støtte og personlig assistanse, og opplev forskjellen SAM-IT kan gjøre i å drive din digitale suksess!"
    },
      
    },
  },
  





  // uk

    uk: {
    translation: {
      // Ukrainian Translation for Service page
      serviceTitle: "Сервіс, якого ви заслуговуєте,",
      serviceSubtitle: "Сервіс, який ми надаємо!",
      serviceDescription:
        "Ми пропонуємо індивідуальні IT-рішення з акцентом на інновації, безпеку та масштабованість. Від експертної технічної підтримки до розробки веб-додатків — наша команда гарантує, що ваша технологія працює бездоганно.",
      curiousAbout: "Цікаво, як SAM-IT UB може трансформувати ваш цифровий досвід?",
      findOutNow: "Дізнатися",
      exploreWork: "Досліджуйте наші роботи в дії та дізнайтесь, чому бізнес і користувачі довіряють нам!",
      liveDemonstartion: "Живий Демо",
      ourServices: "Наші Послуги",
      serviceHeading: "Найкращий захист — це хороший наступ.",
      serviceDetails:
        "Як провідний постачальник керованих послуг в Агдері, Sam-IT Technology Solutions співпрацює з клієнтами для проактивного підходу до IT. Ми усуваємо проблеми до їх виникнення. Коли вони трапляються, ваша команда матиме доступ до IT-підтримки 24/7 і живої Help Desk.",
      itSupport: "IT-підтримка",
      managedServices: "Керовані послуги",
      security: "Безпека",
      helpDesk: "Служба підтримки",

      servicesHeading: "Наші Послуги",
      servicesSubtitle: "Найкращий захист — це хороший наступ.",
      servicesDescription: `
        Як провідний постачальник керованих послуг в Агдері, Sam-IT Technology
        Solutions співпрацює з клієнтами для проактивного підходу до їх IT.
        Ми усуваємо проблеми до їх виникнення. Коли проблеми виникають, ваша команда
        матиме доступ до IT-підтримки та живої Help Desk 24/7/365.`,
      theServiceYouDeserve: "Сервіс, який ви заслуговуєте",
      theServiceWeGive: "Сервіс, який ми надаємо!",
      curiousAboutTransform: "Цікаво, як SAM-IT UB може трансформувати ваш цифровий досвід?",
      findOut: "Дізнатися",
      exploreOurWork: "Досліджуйте нашу роботу в дії та дізнайтесь, чому бізнес і користувачі нам довіряють!",
      liveDemo: "Живий Демо",
      features: {
        itSupport: "IT-підтримка",
        itSupportDescription: "Налаштування, управління та підтримка комп’ютерів і мереж. Координація з постачальниками.",
        managedServices: "Керовані послуги",
        managedServicesDescription: "Планування та обслуговування IT-систем. Проактивний моніторинг. Підтримка на вимогу.",
        security: "Безпека",
        securityDescription: "Захист від шкідливого ПЗ. Моніторинг. Аналіз вразливостей. Планування відновлення даних.",
        helpDesk: "Служба підтримки",
        helpDeskDescription: "Пряма підтримка кінцевих користувачів.",
      },

      // Ukrainian Translation for WhoWeAre page
      whoAreWeTitle: "Хто ми?",
      whoAreWeDescription: `
        SAM-IT UB — це компанія, керована студентами, що пропонує IT-підтримку користувачів та
        розробку для приватних осіб і бізнесу. Ми надаємо ефективні та надійні рішення для ваших цифрових потреб, будь то
        технічна підтримка чи веб-розробка.`,
      whoAreWeMoreDescription: `
        Ми поєднуємо інноваційне мислення з практичним досвідом
        для надання високоякісних IT-послуг. Наша команда відданих студентів
        зосереджена на масштабованості, безпеці та бездоганних рішеннях, забезпечуючи
        безперебійну роботу вашого бізнесу у сучасному технологічному світі. Від
        індивідуальних веб-додатків до персоналізованої підтримки — ми тут, щоб
        покращити ваш цифровий досвід та допомогти вам досягти успіху.`,
      followUs: "Слідкуйте за нами та дізнайтесь більше!",

      // Ukrainian Translation for ChooseSamIT UB section
      chooseSamIT: {
        h1: "Чому обирають Sam-IT?",
        wrapper1: "Кожен наш клієнт має персонального контакту; одна й та сама людина відповідає на ваші дзвінки.",
        wrapper2: "Втрачений час = втрачені доходи. Ми реагуємо миттєво, коли виникають проблеми.",
        wrapper3: "Добрий план зменшує багато можливих проблем. Ми налаштовуємо ваш IT-план відповідно до ваших потреб.",
        wrapper4: "Ми сертифіковані експерти для 20+ провідних постачальників.",
        wrapper5: "Ми працюємо як розширення вашої команди. Ми допоможемо вам досягти ваших цілей."
      },

      // Ukrainian Translation for About Us page
      about_us: {
        title: "Про Sam-IT UB",
        intro1: "SAM-IT — це студентська компанія, що пропонує IT-підтримку та розробку для приватних осіб і бізнесу. Ми надаємо ефективні, надійні рішення для ваших цифрових потреб, будь то технічна підтримка чи веб-розробка.",
        intro2: "Ми поєднуємо інноваційне мислення з практичним досвідом, щоб надавати високоякісні IT-послуги. Наша команда відданих студентів зосереджена на масштабованості, безпеці та бездоганних рішеннях, забезпечуючи безперебійну роботу вашого бізнесу у сучасному технологічному світі. Від індивідуальних веб-додатків до персоналізованої підтримки — ми тут, щоб покращити ваш цифровий досвід та допомогти вам досягти успіху.",
        mission_title: "Наша Місія",
        mission: "Наша місія — надавати бізнесу та приватним особам інноваційні IT-стратегії та рішення, що оптимізують процеси, підвищують продуктивність і сприяють росту.",
        vision_title: "Наше Бачення",
        vision: "Бути надійним партнером для бізнесу в Агдері, пропонуючи передові IT-рішення та консультації, що стимулюють інновації та успіх.",
        why_choose_us: "Чому обирають нас?",
        expert_team_title: "Експертна команда",
        expert_team_desc: "Працюйте з провідними професіоналами галузі, відданими наданню виняткових IT-рішень.",
        tailored_solutions_title: "Індивідуальні рішення",
        tailored_solutions_desc: "Отримайте персоналізовані стратегії, розроблені для вирішення ваших унікальних бізнес-завдань.",
        proven_results_title: "Перевірені результати",
        proven_results_desc: "Користуйтесь рішеннями, що забезпечують вимірний успіх для наших клієнтів.",
        cta_title: "Готові до співпраці з нами?",
        cta_desc: "Давайте трансформуємо ваш бізнес за допомогою експертних IT-рішень та консультацій.",
        contact_us: "Зв'язатися з нами"
      },

      // Ukrainian Translation for Product page
      product: {
        header: "Знайдіть свій ідеальний гаджет",
        subHeader: "Незалежно від того, чи потрібен вам ноутбук для школи, бізнесу, ігор чи особистого користування, наші експерти допоможуть обрати продукт найвищої якості відповідно до ваших потреб.",
        imageAlt: "Консультаційна послуга",
        whyChooseUs: {
          title: "Чому обирають нас?",
          point1: "Персоналізовані рекомендації відповідно до ваших потреб.",
          point2: "Експертні поради для забезпечення високої якості та цінності.",
          point3: "Доступ до ексклюзивних пропозицій та перевірених брендів.",
          point4: "Зекономте час і уникайте плутанини завдяки професійним консультаціям."
        },
        cta: {
          title: "Все ще сумніваєтесь? Дозвольте нашим експертам допомогти!",
          subText: "Замовте безкоштовну консультацію, і ми допоможемо прийняти обґрунтоване рішення відповідно до ваших потреб.",
          buttonText: "Поговорити з експертом"
        }
      },

      // Ukrainian Translation for Faq page
      faq: {
        pageTitle: "Поширені запитання",
        pageDescription: "Відповіді на найчастіші запитання.",
        pageStillConfused: "Все ще не впевнені?",
        contactLinkText: "Не соромтеся зв'язатися з нами.",
        qn_1: "1. Які послуги надає ваша консалтингова компанія?",
        ans_1: "Ми надаємо широкий спектр послуг: IT-підтримку, технічне усунення несправностей, веб-розробку, розробку програмного забезпечення, рішення з кібербезпеки та консультації з цифрової трансформації.",
        qn_2: "2. Як зрозуміти, що мені потрібна IT-консультація?",
        ans_2: "Якщо у вас часті технічні проблеми, потрібно покращити цифрову інфраструктуру або шукаєте поради експертів, ми пропонуємо індивідуальні рішення.",
        qn_3: "3. Як відбувається процес залучення ваших послуг?",
        ans_3: "Процес починається з первинної консультації, після чого ми надаємо детальну пропозицію з підходом, термінами та результатами.",
        qn_4: "4. Чи спеціалізовані ваші послуги під конкретні галузі?",
        ans_4: "Наша команда має досвід у різних галузях, що дозволяє надавати адаптовані IT-рішення для різних секторів.",
        qn_5: "5. Як ваші послуги можуть покращити ефективність моєї компанії?",
        ans_5: "Наші IT-рішення оптимізують робочі процеси, підвищують безпеку, масштабованість та впроваджують інноваційні інструменти для підвищення продуктивності.",
        qn_6: "6. Чим SAM-IT UB відрізняється від інших консалтингових компаній?",
        ans_6: "Наша студентська команда поєднує інноваційне мислення, практичний досвід і свіжий підхід до вирішення проблем, забезпечуючи економічні, масштабовані та безпечні рішення.",
        qn_7: "7. Чи надаєте ви постійну технічну підтримку?",
        ans_7: "Так, ми пропонуємо як разову допомогу, так і постійну підтримку, щоб ваші IT-системи працювали безперебійно.",
        qn_8: "8. Чи допомагаєте ви з веб-розробкою?",
        ans_8: "Звичайно! Наші послуги веб-розробки включають індивідуальні додатки, адаптивний дизайн, обслуговування та оптимізацію.",
        qn_9: "9. Як ви забезпечуєте безпеку даних у ваших рішеннях?",
        ans_9: "Ми пріоритетно ставимо безпеку, впроваджуючи шифрування даних, моніторинг, аналіз вразливостей та плани відновлення після збоїв.",
        qn_10: "10. Ви працюєте як з приватними особами, так і з компаніями?",
        ans_10: "Так, наші індивідуальні рішення підходять для всіх — приватних осіб та компаній.",
        readMore: "Детальніше..."
      },

      // Ukrainian Translation for banner page
      banner: {
        title1: "У світі IT кожна деталь критична для успіху.",
        title2: "Ми відповідаємо за експертизу та поради, які надаємо.",
        bookingBtn: "ЗАБРОНЮВАТИ КОНСУЛЬТАЦІЮ"
      },

      // Ukrainian Translation for DreamsToLife section
      dreamsToLife: {
        title: "Втілюємо ваші мрії в життя",
        intro1: "Ми надаємо все необхідне для розробки, розгортання та підтримки ваших додатків без збоїв.",
        intro2: "Наша команда допомагає на кожному етапі — від концепції до запуску, забезпечуючи правильні інструменти та підтримку для досягнення цілей.",
        "1h3": "Натисніть, щоб розгорнути",
        "1p1": "Легко виведіть ваші додатки в ефір за допомогою наших оптимізованих процесів розгортання.",
        "1p2": "Наша платформа спрощує процес розгортання, щоб ви могли зосередитися на створенні чудового продукту.",
        "2h3": "SSL Сертифікати",
        "2p1": "Ми серйозно ставимося до безпеки. Всі наші послуги мають SSL-сертифікати для захисту додатків та даних користувачів.",
        "2p2": "Впевненість у тому, що ваш додаток відповідає стандартам безпеки галузі.",
        "3h3": "Надійна підтримка",
        "3p1": "Наша команда надає швидку та компетентну підтримку.",
        "3p2": "Ми допомагаємо у вирішенні проблем або надаємо рекомендації, щоб ви могли зосередитися на основній діяльності.",
        "4h3": "Розширена безпека",
        "4p1": "Захистіть ваш додаток за допомогою багаторівневих заходів безпеки.",
        "4p2": "Ми пропонуємо багаторівневий захист, моніторинг та проактивне управління загрозами для захисту даних та користувачів."
      },

      // Ukrainian Translation for digital Journey
      digitalJourney: {
        h2: "Підвищуйте свій цифровий шлях",
        p: "Ми віримо у побудову довгострокових партнерських відносин з нашими клієнтами. Наша команда віддана наданню персоналізованих рішень, що відповідають вашим унікальним бізнес-потребам та забезпечують винятковий сервіс на кожному етапі."
      },

      // Ukrainian Translation for blog section
      blog: {
        blogTitle: "Останні новини та блоги",
        blogDesc: "Будьте в курсі подій завдяки нашим останнім публікаціям.",
        blog_1_h2: "Наш офіс",
        blog_1_h3: "Ласкаво просимо до наших офісів в Арендалі",
        blog_1_p1: "У SAM-IT UB ми раді оголосити про розширення нашої присутності в Арендалі, де ми продовжуємо надавати IT-підтримку та рішення для всіх.",
        blog_1_p2: "Наш новий офіс у Арендалі служить центром інновацій та співпраці...",
        blogLink: "Детальніше...",
        blog_2_h2: "Підтримка користувачів",
        blog_2_h3: "5 поширених IT-проблем та як їх вирішити",
        blog_2_p: "SAM-IT UB пропонує надійну IT-підтримку, включаючи усунення неполадок, встановлення ПЗ та кібербезпеку...",
        blog_3_h2: "Майбутнє IT",
        blog_3_h3: "Тенденції на 2024 та далі",
        blog_3_p: "Оскільки технології швидко розвиваються, важливо залишатися попереду ключових IT-трендів..."
      },

      // Ukrainian Translation for discord banner
      discordBanner: {
        title1: "ПРИВЕДЕНО В ДІЮ ІННОВАЦІЯМИ",
        title2: "Приєднуйтесь до нашої Discord-спільноти підтримки",
         p: "Приєднуйтесь до нашої спільноти на Discord для безперебійної технічної підтримки та персоналізованої допомоги, та відчуйте різницю, яку SAM-IT може зробити для вашого цифрового успіху!"
      }
    }
  }
};


// Initialize i18n
i18n.use(initReactI18next).init({
  resources,
  lng: "no", 
  fallbackLng: "no",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;